import React, { Component } from "react";
import style from "./Statements.module.css";
import { connect } from "react-redux";
import { Field, Form, Formik } from "formik";
import moment from "moment";
import { DatePicker } from "antd";
import * as Yup from "yup";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import {
  TabContent,
  TabPane,
  Nav,
  NavItem,
  NavLink,
  Card,
  Button,
  CardTitle,
  CardText,
  Row,
  Col,
} from "reactstrap";
import {
  fetchStatementsListing,
  fetchInitialStatementsDataListing,
  fetchTransaction,
  paymentDetailsShareViaEmail,
} from "../../redux";
import ttmLoader from "../../assets/images/ttm-loader.gif";
import { Modal, ModalHeader, ModalBody } from "reactstrap";
import ReactToPrint from "react-to-print";
import api from "../../utils/Api";
import { Link } from "react-router-dom";
import { dateFormatter, formatNumberToCurrency } from "../../utils/CommonUtil";


// This is initial model for payload.
const model = {
  supplier_id: "",
  dateFrom: "",
  dateTo: "",
};

/**
 * This component is created for the statements module.
 */
export class Supplier extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ...model,
      page: 1,
      sortName: "",
      sortOrder: "",
      sortBy: "",
      isDataFetched: false,
      paymentForType: 2,
      statementsList: [],
      payment_id: "",
      isModalOpen: false,
      isReportGenerated: true,
    };
    this.setLoader = this.setLoader.bind(this);
  }

  /**
   * This method called when thre component is loaded in the DOM.
   */
  componentDidMount = async () => {
    await this.props.fetchInitialStatementsDataListing();
    await this.props.fetchStatementsListing(
      this.state.sortBy,
      this.state.page,
      model,
      this.state.paymentForType
    );
    this.setState({
      statementsList: this.props.statementListingData.statementsList.payments,
    });
    setTimeout(() => {
      if (this.props.statementListingData.statementsList.total === 0) {
        this.setState({
          isDataFetched: true,
        });
      } else {
        this.setState({
          isDataFetched: false,
        });
      }
    }, 1000);
  };

  /**
   * This will return payload object.
   */
  getPayload = () => {
    return {
      supplier_id: this.state.supplier_id,
      dateFrom: dateFormatter(this.state.dateFrom),
      dateTo: dateFormatter(this.state.dateTo),
    };
  };

  /**
   * This method will call fetch Statement API with the required params as payload.
   */
  callfetchStatementAPI = async () => {
    this.setState({
      statementsList: [],
    });
    const payload = this.getPayload();
    await this.props.fetchStatementsListing(
      this.state.sortBy,
      this.state.page,
      payload,
      this.state.paymentForType
    );
    if (!this.props.statementListingData.loading) {
      this.setState({
        statementsList: this.props.statementListingData.statementsList.payments,
      });
      setTimeout(() => {
        this.setState({
          isDataFetched: true,
        });
      }, 1000);
    }
  };

  /**
   * This method will export transaction details to excel file.
   */
  handleExport = async () => {
    this.setState({
      isReportGenerated: false,
    });
    const headers = {
      Accept: "application/xls",
      Authorization:
        "Bearer " + JSON.parse(localStorage.getItem("USER_INFO")).token,
    };

    const payload = this.getPayload();

    let url = "payment/statement/export?sort_by=" + this.state.sortBy;

    if (payload && payload.practitioner_id) {
      url += "&practitioner_id=" + payload.practitioner_id;
    }
    if (payload && payload.patient_id) {
      url += "&patient_id=" + payload.patient_id;
    }
    if (payload && payload.supplier_id) {
      url += "&supplier_id=" + payload.supplier_id;
    }
    if (payload && payload.dateFrom) {
      url += "&payment_date=gte:" + payload.dateFrom;
    }
    if (payload && payload.dateTo) {
      url += "&payment_date=lte:" + payload.dateTo;
    }

    try {
      const response = await api.get(url, {
        headers: headers,
        responseType: "blob",
      });
      if (response.status == 200) {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `Statements.xlsx`);
        document.body.appendChild(link);
        link.click();
        this.setState({
          isReportGenerated: true,
        });
      }
    } catch (error) {
      this.setState({
        isReportGenerated: true,
      });
      console.log("Error for exporting the statements data!", error);
    }
  };

  /**
   * This method will be called when the sorting is changed in the table.
   */
  onSortChange = (sortName, sortOrder) => {
    let sortBy;
    if (sortOrder == "desc") {
      sortBy = "-" + sortName;
    } else {
      sortBy = sortName;
    }
    this.setState(
      {
        sortName,
        sortOrder,
        sortBy,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.callfetchStatementAPI();
      }
    );
  };

  /**
   * This method is called when page changes through pagination.
   */
  onPageChange = (page, sizePerPage) => {
    this.setState({ page, isDataFetched: false }, () => {
      this.callfetchStatementAPI();
    });
  };

 
  /**
   * This method will be called when supplier filter is changed.
   */
  handleSupplierChange = (event) => {
    let filterval = event.target.value;

    this.setState(
      {
        supplier_id: filterval,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.props.updateState(this.state);
        this.callfetchStatementAPI();
      }
    );
  };

  /**
   * This method will be called when date from filter is changed.
   */
  handleDateFrom = (date) => {
    this.setState(
      {
        dateFrom: date,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.props.updateState(this.state);
        this.callfetchStatementAPI();
      }
    );
  };

  /**
   * This method will be called when date to filter is changed.
   */
  handleDateTo = (date) => {
    this.setState(
      {
        dateTo: date,
        page: 1,
        isDataFetched: false,
      },
      () => {
        this.props.updateState(this.state);
        this.callfetchStatementAPI();
      }
    );
  };

  

  /**
   * This method will be called when view eye icon is clicked.
   * @param {object} val object data of the table row
   */
  viewAction = (val) => {
    this.setState(
      (prevState) => ({
        payment_id: val.payment_id,
        isModalOpen: !prevState.isModalOpen,
      }),
      () => {
        if (this.state.isModalOpen) {
          this.props.fetchTransaction(val.payment_id);
        }
      }
    );
  };

  /**
   * This method will be called when there is not data or data is being fetched to show the loader.
   */
  setLoader() {
    if (this.state.isDataFetched) {
      return <p>There is no data to display</p>;
    } else {
      return (
        <div>
          <img src={ttmLoader} alt="loader" className="loader-image" />
        </div>
      );
    }
  }

  /**
   * This method will be called to format the table data for valid data.
   * @param {string} data of the table column.
   * @returns {string} data or Not available string
   */
  checkValidData = (data) => {
    if (!data) {
      return "Not Available";
    } else {
      return data;
    }
  };

  /**
   * This method will be called to format the table data for valid data.
   * @param {string} data of the table column.
   * @returns {string} data with first letter capital or Not available string
   */
  detailFormatter = (data) => {
    if (!data) {
      return "Not Available";
    } else {
      return data.charAt(0).toUpperCase() + data.slice(1);
    }
  };

  /**
   * This method will clear all the filters which are selected.
   */
  handleClearFilters = () => {
    this.setState(
      {
        ...model,
        page: 1,
        sortName: "",
        sortOrder: "",
        sortBy: "",
        isDataFetched: false,
      },
      () => {
        this.props.updateState(this.state);
        this.callfetchStatementAPI();
      }
    );
  };

  /**
   * This will return filter form HTML for the render method.
   */
  getFilter = () => {
    const initialStatementsData = this.props.initialStatementsData
      .initialStatementsData;

    const supplierOptionsData =
      initialStatementsData &&
      initialStatementsData.supplier &&
      initialStatementsData.supplier.length > 0 &&
      initialStatementsData.supplier.map((element, index) => (
        <option key={index} value={element.supplier_id}>
          {element.supplier_name}
        </option>
      ));

    return (
      <Formik initialValues={this.state} enableReinitialize={true}>
        <Form>
          <div className={`row form-group ${style.statementFilterForm}`}>
            
              <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
                <label>Supplier</label>
                <Field
                  name="supplier_id"
                  as="select"
                  placeholder="Supplier"
                  onChange={this.handleSupplierChange}
                  className="form-control"
                >
                  <option value="">Select Supplier</option>
                  {supplierOptionsData}
                </Field>
              </div>

            <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label>Date From</label>
              <DatePicker
                name="dateFrom"
                onChange={this.handleDateFrom}
                placeholder="Date From"
                className="form-control"
                value={this.state.dateFrom}
                disabledDate={(d) => !d || d.isAfter(this.state.dateTo)}
              />
            </div>

            <div className="col-sm-6 col-md-6 col-lg-3 mb-3 mb-lg-0">
              <label>Date To</label>
              <DatePicker
                name="dateTo"
                onChange={this.handleDateTo}
                placeholder="Date To"
                className="form-control"
                value={this.state.dateTo}
                disabledDate={(d) => !d || d.isBefore(this.state.dateFrom)}
              />
            </div>
          </div>
        </Form>
      </Formik>
    );
  };

  // Adding actions view icon
  actionsFormatter(cell, row) {
    return (
      <div>
        <Link title="View Statement" onClick={() => this.viewAction(row)}>
          <i className="fa fa-eye relatedpartylist-edit-icon"></i>
        </Link>
      </div>
    );
  }

  /**
   * This is modal pop up html
   */
  modalPopUp() {
    const paymentDetails = this.props.transactionData.transactionDetails;
    const paymentProof = paymentDetails.paymentProof;
    return (
      <Modal
        isOpen={this.state.isModalOpen}
        toggle={this.viewAction}
        className="payment-history-modal"
        centered
      >
        {this.props.loadingTransaction ? (
          <div className={style.loadingWrapper}>
            <img src={ttmLoader} alt="modal-loader" className={style.loading} />
          </div>
        ) : (
          <React.Fragment>
            <ModalHeader
              toggle={this.viewAction}
              className={style.paymentModalHeader}
            >
              Payment -{" "}
              {paymentDetails.payment && paymentDetails.payment.transaction_id}
            </ModalHeader>
            <ModalBody className={style.paymentHistoryModal}>
              <div ref={(el) => (this.componentRef = el)}>
                <div className="row">
                  <div className="col-lg-12">
                    <h4>Payment Details</h4>
                  </div>
                </div>
                {/* {this.props.loadingTransaction ? (
              <div className={style.loadingWrapper}>
                <img src={ttmLoader} className={style.loading} />
              </div>
            ) : ( */}
                <div className="row">
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Transaction Number:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.payment &&
                            this.checkValidData(
                              paymentDetails.payment.transaction_id
                            )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Payment Date:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.payment &&
                            this.checkValidData(
                              moment(paymentDetails.payment.created_at).format(
                                "YYYY-MM-DD"
                              )
                            )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Payer Name:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.paymentDetail &&
                            this.checkValidData(
                              paymentDetails.paymentDetail.payer_name
                            )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Payee Name:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.paymentDetail &&
                            this.checkValidData(
                              paymentDetails.paymentDetail.payee_name
                            )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Payer Bank Name:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.paymentDetail &&
                            this.checkValidData(
                              paymentDetails.paymentDetail.payer_bank_name
                            )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Payee Bank Name:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.paymentDetail &&
                            this.checkValidData(
                              paymentDetails.paymentDetail.payee_bank_name
                            )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Payer Account Number:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.paymentDetail &&
                            this.checkValidData(
                              paymentDetails.paymentDetail.payer_account_number
                            )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Payee Account Number:</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.paymentDetail &&
                            this.checkValidData(
                              paymentDetails.paymentDetail.payee_account_number
                            )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="col-lg-6">
                    <div className="row">
                      <div className="col-lg-6">
                        <p>Amount (ZAR):</p>
                      </div>
                      <div className="col-lg-6">
                        <p>
                          {paymentDetails.paymentDetail &&
                            this.checkValidData(
                              paymentDetails.paymentDetail.payment_amount
                            )}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                {/* )} */}
              </div>
              <div className="row">
                <div className="col-md-12">
                  {paymentProof && paymentProof.length !== 0 && (
                    <h4 className="mt-4">Proof of Payment</h4>
                  )}
                </div>
              </div>
            </ModalBody>
          </React.Fragment>
        )}
      </Modal>
    );
  }

  /**
   * This is render method.
   */
  render() {
    //const statementListingData = this.props.statementListingData.statementsList
    return (
      <div>
        {this.props.loading ? (
          <div className={style.loadingWrapper}>
            <img src={ttmLoader} alt="loader" className={style.loading} />
          </div>
        ) : (
         <div className="inventory-tab-wrapper flex-wrap">
                        <div className="row">
                          <div className="col-md-12">{this.getFilter()}</div>

                          <div className="col-md-12">
                            <a
                              className={style.clearFilters}
                              href="javascriptVoid:0"
                              onClick={this.handleClearFilters}
                            >
                              Clear Filters
                            </a>
                          </div>
                        </div>

                        <div className="row">
                          <div className="col-md-12">
                            <BootstrapTable
                              remote={true}
                              bordered={false}
                              data={this.state.statementsList}
                              version="4"
                              search={false}
                              pagination
                              fetchInfo={{
                                dataTotalSize: this.props.statementListingData
                                  .statementsList.total,
                              }}
                              options={{
                                searchvalue: "",
                                sortName: this.state.sortName,
                                sortOrder: this.state.sortOrder,
                                onSortChange: this.onSortChange,
                                // onSearchChange: this.onSearchChange,
                                sizePerPage: 10,
                                page: this.state.page,
                                onPageChange: this.onPageChange,
                                noDataText: this.setLoader(),
                              }}
                            >
                              <TableHeaderColumn
                                isKey
                                dataField="transaction_id"
                                dataSort={true}
                                width="19%"
                              >
                                Transaction Id
                              </TableHeaderColumn>
                                <TableHeaderColumn
                                  dataField="supplier_name"
                                  dataSort={true}
                                  dataFormat={this.checkValidData}
                                  width="16%"
                                >
                                  Supplier
                                </TableHeaderColumn>
                              <TableHeaderColumn
                                dataField="payment_mode"
                                dataSort={true}
                                dataFormat={this.checkValidData}
                                width="10%"
                              >
                                Mode
                              </TableHeaderColumn>

                              <TableHeaderColumn
                                dataField="payment_type"
                                dataSort={true}
                                dataFormat={this.detailFormatter}
                                width="10%"
                              >
                                Type
                              </TableHeaderColumn>
                              <TableHeaderColumn
                                dataField="created_at"
                                dataFormat={dateFormatter}
                                dataSort={true}
                                width="15%"
                              >
                                Date
                              </TableHeaderColumn>
                              <TableHeaderColumn
                                dataField="amount"
                                dataSort={true}
                                dataFormat={formatNumberToCurrency}
                                width="10%"
                              >
                                Amount (ZAR)
                              </TableHeaderColumn>
                              <TableHeaderColumn
                                dataField="actions"
                                dataFormat={this.actionsFormatter.bind(this)}
                                width="10%"
                              >
                                Actions
                              </TableHeaderColumn>
                            </BootstrapTable>
                          </div>
                        </div>
                      </div>
                  )}
             {this.modalPopUp()}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    statementListingData: state.statementsList,
    initialStatementsData: state.initialStatementsData,
    transactionData: state.transactionDetails,
    loadingTransaction: state.transactionDetails.loading,
    paymentDetailsData: state.paymentDetailsData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchStatementsListing: (sortBy, page, payload, paymentForType) =>
      dispatch(fetchStatementsListing(sortBy, page, payload, paymentForType)),
    fetchInitialStatementsDataListing: () =>
      dispatch(fetchInitialStatementsDataListing()),
    fetchTransaction: (payment_id) => dispatch(fetchTransaction(payment_id)),
    paymentDetailsShareViaEmail: (payment_id) =>
      dispatch(paymentDetailsShareViaEmail(payment_id)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Supplier);
